import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tmxActions from '../Actions/tmxActions';
import QAErrorList from "../Components/QA/QAErrorList";
import { qaService } from "../Services/QAService.js";
 import { Link } from 'react-router-dom';

class QAListContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			processing: false,
			qaErrors: [],
		};
		this.qaAccept  = this.qaAccept.bind(this);
		this.qaDecline = this.qaDecline.bind(this);
		this.qaSwitchError = this.qaSwitchError.bind(this);
	}
	
	componentDidMount() {
		qaService.listErrors(this.props.orderRecord.id)
					.then(response => this.setState({qaErrors: response.data}))
					.catch(err => {/*console.log(err);*/});
	}
	
	qaAccept(){
		this.setState({processing: true});
		qaService.setQA(this.props.orderRecord.id, 1)
				.then(response => this.props.history.push('/orderList'))
				.catch(err => {/*console.log(err);*/});
	}
	qaDecline(){
		let xlifDocumentId=0;
		this.setState({processing: true});
		qaService.setQA(this.props.orderRecord.id, 0)
				.then(response =>{	const order= response.data;
									for (var i = 0; i < order.phase.length; i++) {
										if(order.phase[i].type=="TRANSLATION"){
											if(order.phase[i].document && order.phase[i].document.id){
												xlifDocumentId=order.phase[i].document.id;
											}
										}
									}
									
									if(xlifDocumentId && xlifDocumentId>0){
										return this.props.history.push('/editor/'+this.props.orderRecord.id+'/'+xlifDocumentId)
									}else{
										return this.props.history.go(-1)
									}
									
								})
				.catch(err => {/*console.log(err);*/});
	}
	qaSwitchError(errorId, enabled){
		qaService.switchQAError(errorId, enabled)
			.then(response => { let errorList = this.state.qaErrors;
								let errors = errorList.errors.map(error => { console.log(error); return error.id===errorId ? response.data : error});
								errorList.errors=errors;
								this.setState({qaErrors: errorList});
								return 1;
								})
			.catch(err => {/*console.log(err);*/});
	}
	
	render() {
		if(this.state.processing){
			return <div className="content">PROCESSING...</div>
		}else{
			return (<div className="content">
					<h2 className="title">QA</h2>
					<QAErrorList
						errors={this.state.qaErrors.errors}
						acceptAction={this.qaAccept}
						declineAction={this.qaDecline}
						switchAction={this.qaSwitchError}
					/>
					</div>);
		}
	}
}

function mapStateToProps(state, ownProps) {
	return {user: state.user,
			orderRecord: state.orders[ownProps.match.params.idOrder]}
}

export default connect(mapStateToProps)(QAListContainer);  